import { FC, useState } from 'react';
import { Flex } from '@chakra-ui/react';
import SelectOverview from '../Select/select';
import { useTranslation } from 'react-i18next';
import { GlobeIcon } from 'src/utils/icons/globe';

const languages = [
	{
		value: 'pl',
		label: 'PL',
	},
	{
		value: 'en',
		label: 'EN',
	},
];

interface LanguageProps {
	onClickEvent: any;
}

export const LanguageSelect: FC<LanguageProps> = ({ onClickEvent }) => {
	const { t, i18n } = useTranslation();

	const [selectedLanguage, setSelectedLanguage] = useState(
		languages.filter(language => i18n.language.includes(language.value))[0]
	);
	const [isClicked, setIsClicked] = useState(false);

	const changeLanguage = (lang: { value: string; label: string }) => {
		
		setIsClicked(false);
		setSelectedLanguage(lang);
		i18n.changeLanguage(lang.value).then(() => {
			console.log("XD")
		});
		
		
	};	

	return (
		<Flex
			cursor="pointer"
			alignItems="center"
			onClick={onClickEvent}
		>
			<GlobeIcon width="14px" />
			<SelectOverview
				isSearchable={false}
				onChange={changeLanguage}
				options={languages.map(language => ({ value: language.value, label: language.label }))}
				value={selectedLanguage}
				placeholder={t('default.selectLanguage')}
			/>
		</Flex>
	);
};
